/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";

/** Common Components */
import Buttons from "../../../../components/ui/button/Buttons";
import FormCreator from "../../../../components/finalForms/FormCreator";

/** Common Services & Data Files */
import { AppIcons } from "../../../../data/appIcons";
import FormData from "./config/ProjectDomain.data";
import ToastService from "../../../../services/toastService/ToastService";

/** RTK Query */
import {
  useAddProjectDomainMutation,
  useLazyGetProjectDomainByIdQuery,
  useUpdateProjectDomainMutation,
} from "../../../../app/services/projectDomainAPI";

export const AddEditDomain = (props) => {

  const ProjectDomainRef = useRef();
  const [projectDomainForm, setProjectDomainForm] = useState(FormData);

  //** API Call's */
  const [addProjectDomain, {
    isSuccess: isProjectDomainAdded,
    isLoading: isProjectDomainAdding,
    data: addProjectDomainData
  },] = useAddProjectDomainMutation();

  const [getProjectDomainById, {
    isFetching: isGetByIdFetching,
    isSuccess: isGetByIdSuccess,
    data: getByIdData
  },] = useLazyGetProjectDomainByIdQuery();

  const [updateProjectDomain, {
    isLoading: isProjectDomainUpdating,
    isSuccess: isProjectDomainUpdateSuccess,
    data: updateProjectDomainData
  },] = useUpdateProjectDomainMutation();

  //** Use Effects */
  useEffect(() => {
    formReset();
    if (props.projectDomainId) {
      getProjectDomainById(props.projectDomainId)
    }
  }, [getProjectDomainById]);

  useEffect(() => {
    if (!isGetByIdFetching && isGetByIdSuccess && getByIdData) {
      if (getByIdData) {
        let updatedForm = { ...projectDomainForm };
        updatedForm.initialState = {
          ...updatedForm.initialState,
          projectDomainName: getByIdData.projectDomainName,
          isActive: getByIdData.isActive,
        };
        setProjectDomainForm(updatedForm);
      }
    }
  }, [isGetByIdFetching, isGetByIdSuccess, getByIdData]);

  useEffect(() => {
    if (isProjectDomainAdded && addProjectDomainData) {
      if (addProjectDomainData.errorMessage?.includes("exists")) {
        ToastService.warning(addProjectDomainData.errorMessage);
      } else {
        ToastService.success(addProjectDomainData.errorMessage);
        props.onSuccess();
        backToList();
      }
    }
  }, [isProjectDomainAdded, addProjectDomainData]);

  useEffect(() => {
    if (isProjectDomainUpdateSuccess && updateProjectDomainData) {
      if (updateProjectDomainData.errorMessage.includes("exists")) {
        ToastService.warning(updateProjectDomainData.errorMessage);
      } else {
        ToastService.success(updateProjectDomainData.errorMessage);
        props.onSuccess();
        backToList();
      }
    }
  }, [isProjectDomainUpdateSuccess, updateProjectDomainData]);

  //** Funcation's */
  const handleSubmit = () => {
    const ProjectDomainManagementData = ProjectDomainRef.current.getFormData();
    if (!props.projectDomainId && ProjectDomainManagementData) {
      const requestData = {
        projectDomainName: ProjectDomainManagementData.projectDomainName,
        isActive: ProjectDomainManagementData.isActive || false,
      };
      addProjectDomain(requestData);
    } else if (props.projectDomainId && ProjectDomainManagementData) {
      const requestUpdateData = {
        projectDomainId: props.projectDomainId,
        projectDomainName: ProjectDomainManagementData.projectDomainName,
        isActive: ProjectDomainManagementData.isActive,
      };
      updateProjectDomain(requestUpdateData);
    }
  };

  const formReset = () => {
    const resetForm = { ...FormData };
    resetForm.initialState = { ...FormData.initialState };
    setProjectDomainForm(resetForm);
  };

  const backToList = () => {
    props.onClose();
    formReset();
  };

  return (
    <>
      <FormCreator config={projectDomainForm} ref={ProjectDomainRef} {...projectDomainForm} />

      <div className="form-btn d-flex justify-content-end">
        <Buttons
          buttonTypeClassName="dark-btn"
          onClick={backToList}
          buttonText="Cancel"
        />
        <Buttons
          buttonTypeClassName="theme-btn ml-4"
          imagePath={AppIcons.AddIcon}
          buttonText={props.projectDomainId ? "Update" : "Add"}
          onClick={handleSubmit}
          isLoading={isProjectDomainAdding || isProjectDomainUpdating}
        />
      </div>
    </>
  );
};

AddEditDomain.propTypes = {
  projectDomainId: PropTypes.number,
  onClose: PropTypes.func,
  onSuccess: PropTypes.func
};

export default AddEditDomain;
